// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-ydui@1.2.6@vue-ydui/dist/ydui.rem.css
// module id = 1132
// module chunks = 192